.avatar {
  position: relative;
  display: inline-grid;
  flex: 0 0 auto;
  place-items: center;
  overflow: visible;
  border: 1px solid var(--arc-border);
  border-radius: var(--identity-avatar-radius);
  background: var(--arc-surface-muted);
  color: var(--arc-foreground);
  font-size: var(--arc-text-xs);
  font-weight: 500;
}

.avatar img {
  pointer-events: none;
  border-radius: inherit;
  object-fit: cover;
  transition: opacity var(--arc-duration-standard) var(--arc-ease-enter), filter var(--arc-duration-standard) var(--arc-ease-enter);
}

/* Set only while a photo is still downloading after mount, so cached photos never fade. */
.avatar img[data-loading] {
  opacity: 0;
  filter: blur(4px);
  transition: none;
}

.fallback { animation: avatar-fallback-in var(--arc-duration-standard) var(--arc-ease-enter) both; }

.sm { width: var(--identity-avatar-sm); height: var(--identity-avatar-sm); font-size: 10px; }
.md { width: var(--identity-avatar-md); height: var(--identity-avatar-md); }
.lg { width: var(--identity-avatar-lg); height: var(--identity-avatar-lg); font-size: var(--arc-text-sm); }
.xl { width: var(--identity-avatar-xl); height: var(--identity-avatar-xl); font-size: var(--arc-text-xl); }

.status {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 10px;
  height: 10px;
  border: 2px solid var(--arc-surface);
  border-radius: var(--identity-avatar-radius);
  box-shadow: 0 0 0 1px color-mix(in oklab, var(--arc-border) 70%, transparent);
}

.sm .status { width: 8px; height: 8px; border-width: 1.5px; }
.lg .status { width: 12px; height: 12px; }
.xl .status { width: 14px; height: 14px; right: 4px; bottom: 4px; }
.online { background: var(--arc-success); }
.offline { background: var(--arc-text-muted); }

@keyframes avatar-fallback-in { from { opacity: 0; } to { opacity: 1; } }

@media (prefers-reduced-motion: reduce) {
  .avatar img { transition: none; }
  .avatar img[data-loading] { filter: none; }
  .fallback { animation: none; }
}

.avatar[data-reduced-motion] img { transition: none; }
.avatar[data-reduced-motion] img[data-loading] { filter: none; }
.avatar[data-reduced-motion] .fallback { animation: none; }
